import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-header',
  templateUrl: 'header.component.html'
})
export class HeaderComponent implements OnInit, OnDestroy {
  constructor(
  ) { }

  navbarOpen = false;
  unsubscribe$ = new Subject();
  links = [
    {
      text: 'Home',
      url: '/',
    },
    {
      text: 'Resources',
      url: '/resources',
    },
    {
      text: 'Schedule',
      url: '/schedule',
    },
    {
      text: 'Speakers',
      url: '/speakers',
    },
    {
      text: 'Sessions',
      url: '/sessions',
    },
    {
      text: 'Sponsors',
      url: '/sponsors',
    },
    {
      text: 'About',
      url: '/about',
    },
    {
      text: 'Contact',
      url: '/contact',
    },
    // {
    //   text: 'Call for Speakers',
    //   url: 'https://sessionize.com/iowa-code-camp-fall-2024/',
    //   external: true
    // },
  ];

  ngOnInit() {
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(true);
  }

  toggleNavbar():void {
    this.navbarOpen = !this.navbarOpen;
  }

  handleHamburgerButtonClick():void {
    this.toggleNavbar();
  }

  handleOverlayClick(): void {
    alert('yep');
  }
}
